import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../services/options.service'
import { setCriticalCareSiteOptions } from '../store/options.actions'

export function* getCriticalCareSiteOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const criticalCareSiteOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getCriticalCareSiteOptions,
    ])
    const { entity } = criticalCareSiteOptionsResponse
    if (entity) yield put(setCriticalCareSiteOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCriticalCareSiteOptions() error: ${e}`))
  }
}

export function* getCriticalCareSiteOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCriticalCareSiteOptions)
}
